<ng-container *ngIf="traveler$ | async as t">
  <div class="regular-type" *ngIf="t.firstName" data-hj-suppress data-dd-privacy="hidden">
    <div class="nordic-blue-900-text text-icon-primary capitalize">{{ t.type | finLocalization }}</div>
    <div class="capitalize">{{ t.firstName }} {{ t.lastName }}</div>
    <div class="nordic-blue-900-text text-icon-primary" *ngIf="t.withInfantFullName">
      {{ 'passenger.withInfant' | finLocalization: { withInfantFullName: t.withInfantFullName } }}
    </div>
    <div *ngIf="t.email">{{ 'passengerReview.email' | finLocalization }} {{ t.email }}</div>
    <div *ngIf="t.birthDate">
      {{ 'passengerReview.dateOfBirth' | finLocalization }} {{ t.birthDate | finDateFormat: 'DATE' }}
    </div>
    <div *ngIf="t.phone">{{ 'passengerReview.phone' | finLocalization }} {{ t.phone }}</div>
  </div>
</ng-container>
